import { useMutation } from 'react-query';

import { saveFilterBulkRemoveTags as mutationFn } from 'api/endPoints/saveFilterBulkRemoveTags';

import { IFilter } from 'components/Dashboards/Project/Components/CustomDashboard/utils/utils.type';

export const useMutationSaveFilterBulkRemoveTags = () => {
    return useMutation<string, QueryError, QueryParams>({
        mutationFn: (params) => mutationFn(params),
    });
};

interface QueryParams {
    body: {
        bulkAssigneeToUserUniqIdNotification: number;
        bulkAssignee: number;
        filter: {
            filters: IFilter;
        };
        paging: {
            page: number;
            size: number;
        };
        withDetails: boolean;
    };
    querystring: {
        lastRunActivities: number;
    };
}
